/**
 * AdminService — cross-tenant super-admin panel API.
 * All endpoints are gated server-side to settings.admin_emails.
 */
import { ApiClient } from './api';

export class AdminService {
  constructor(getToken) {
    this.client = new ApiClient(getToken);
  }

  getAccess(options = {}) {
    return this.client.get('/admin/access', options);
  }

  getOverview(options = {}) {
    return this.client.get('/admin/overview', options);
  }

  getTenants(options = {}) {
    return this.client.get('/admin/tenants', options);
  }

  getAiUsage(options = {}) {
    return this.client.get('/admin/ai-usage', options);
  }

  setAgentConfig(payload, options = {}) {
    return this.client.post('/admin/agent-config', payload, options);
  }
}

export default AdminService;
